
import { item as item_5, unzip, singleton as singleton_1, cons, toArray, ofArray, allPairs, indexed, map as map_1, fold, collect, append, filter, head, empty, tail, isEmpty } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { evalExpr, DeclarationDU, getPrimaryLocation, getAllExpressions$0027, unrollForLoops, getItem, convertModule, evalExprWithParams, getAssignments$0027, getContAssignments, getPrimaryName, getNonBlockingAssignmentsWithLocation, getBlockingAssignmentsWithLocation, AlwaysDU, ASTNode, getAlwaysBlocks, foldAST } from "./VerilogAST.js";
import { int32ToString, compare, safeHash, stringHash, comparePrimitives, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { findCloseVariable, getWireSizeMap, getModuleInstantiationStatements, getPrimaryBits, getRHSBits, primariesUsedInAssignment, checkExpr, getCaseItemNums, getAlwaysBlocksWithLocations, getLHSBits$0027, getForStatementsWithLoc, getLHSBitsAssignedCertainly, getCaseStatementsWithLoc, getLineNumber, getWidthOfExpr, getDeclarations, createErrorMessage } from "./ErrorCheckHelpers.js";
import { toFail, printf, toText } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { ExtraErrorInfo, ReplaceType } from "./VerilogTypes.js";
import { ofArray as ofArray_1, FSharpSet__Add, FSharpSet__Contains, contains, filter as filter_1, map as map_3, difference, count, toList as toList_1, intersect, isEmpty as isEmpty_1, empty as empty_1, add, union, fold as fold_1, ofList, singleton } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { filter as filter_2, map as map_4, empty as empty_2, add as add_1, fold as fold_2, find, keys, tryFind, containsKey } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { List_distinct } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { map as map_5, delay, tryPick, toList } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { rangeBigInt, rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { tryFind as tryFind_1, append as append_1, map as map_2, collect as collect_1, fold as fold_3, item as item_4 } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { orElse, defaultArg, value as value_3 } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { strToIntCheckWidth, toDecimal } from "../Simulator/NumberHelpers.js";
import { parse } from "../fable_modules/fable-library-js.5.13.0/Int32.js";
import { toString, op_Subtraction, fromZero, fromInt32, fromOne, op_LeftShift, compare as compare_1 } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { MapModule_KeysL } from "../Common/EEExtensions.js";

function convert(lst_mut, acc_mut) {
    convert:
    while (true) {
        const lst = lst_mut, acc = acc_mut;
        if (!isEmpty(lst)) {
            if (isEmpty(tail(lst))) {
                lst_mut = empty();
                acc_mut = (acc + head(lst));
                continue convert;
            }
            else {
                lst_mut = tail(lst);
                acc_mut = ((acc + head(lst)) + ", ");
                continue convert;
            }
        }
        else {
            return acc;
        }
        break;
    }
}

/**
 * Checks if always_comb only contains blocking assignments and always_ff only contains nonblocking assignments
 */
export function checkProceduralAssignments(ast, linesLocations, errorList) {
    const alwaysBlocks_1 = foldAST(getAlwaysBlocks, empty(), new ASTNode(/* VerilogInput */ 21, [ast]));
    const clockedAlwaysBlocks = filter((always) => equals(always.AlwaysType, AlwaysDU.AlwaysFF), alwaysBlocks_1);
    const combAlwaysBlocks = filter((always_1) => equals(always_1.AlwaysType, AlwaysDU.AlwaysComb), alwaysBlocks_1);
    return append(errorList, append(collect((alwaysBlock) => fold((errors, tupledArg) => append(errors, createErrorMessage(linesLocations, tupledArg[1], toText(printf("Blocking assignment in always_ff block")), [new ExtraErrorInfo(toText(printf("Blocking assignment in a clocked always block is not supported.\nPlease use nonblocking assignments in clocked always blocks")), false, ReplaceType.NoReplace), new ExtraErrorInfo(toText(printf("<=")), true, new ReplaceType(/* Variable */ 2, ["="]))], "=")), empty(), foldAST(getBlockingAssignmentsWithLocation, empty(), new ASTNode(/* AlwaysConstruct */ 4, [alwaysBlock]))), clockedAlwaysBlocks), collect((alwaysBlock_1) => fold((errors_1, nonblocking) => append(errors_1, createErrorMessage(linesLocations, nonblocking[1], toText(printf("Nonblocking assignment in always_comb block")), [new ExtraErrorInfo(toText(printf("Nonblocking assignment in a combinational always block is not supported.\nPlease use blocking assignments in combinational always blocks")), false, ReplaceType.NoReplace), new ExtraErrorInfo(toText(printf("=")), true, new ReplaceType(/* Variable */ 2, ["<="]))], "<=")), empty(), foldAST(getNonBlockingAssignmentsWithLocation, empty(), new ASTNode(/* AlwaysConstruct */ 4, [alwaysBlock_1]))), combAlwaysBlocks)));
}

/**
 * Checks if a variable is driven by multiple always blocks or continuous assignments
 * Could be improved if it printed out the variables / marked the error at the location of the variables
 */
export function checkVariablesDrivenSimultaneously(ast, linesLocations, arraySizeMap, errorList) {
    let arg, arg_1;
    const alwaysBlocks_1 = foldAST(getAlwaysBlocks, empty(), new ASTNode(/* VerilogInput */ 21, [ast]));
    const alwaysAssignmentBits = append(map_1((assign_1) => singleton(getPrimaryName(assign_1.LHS.PrimaryType), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), filter((assign) => !containsKey(getPrimaryName(assign.LHS.PrimaryType), arraySizeMap), foldAST(getContAssignments, empty(), new ASTNode(/* VerilogInput */ 21, [ast])))), map_1((alwaysBlock) => ofList(List_distinct(map_1((assign_2) => getPrimaryName(assign_2.LHS.PrimaryType), foldAST(getAssignments$0027, empty(), new ASTNode(/* AlwaysConstruct */ 4, [alwaysBlock]))), {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: (x_1) => (stringHash(x_1) | 0),
    }), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    }), alwaysBlocks_1));
    let alwaysAssignmentArrayBits;
    const list_11 = map_1((alwaysBlock_1) => ofList(List_distinct(map_1((assign_4) => assign_4.LHS, filter((assign_3) => containsKey(getPrimaryName(assign_3.LHS.PrimaryType), arraySizeMap), foldAST(getAssignments$0027, empty(), new ASTNode(/* AlwaysConstruct */ 4, [alwaysBlock_1])))), {
        Equals: equals,
        GetHashCode: (x_3) => (safeHash(x_3) | 0),
    }), {
        Compare: (x_4, y_4) => (compare(x_4, y_4) | 0),
    }), alwaysBlocks_1);
    alwaysAssignmentArrayBits = append(map_1((assign_6) => singleton(assign_6.LHS, {
        Compare: (x_5, y_5) => (compare(x_5, y_5) | 0),
    }), filter((assign_5) => containsKey(getPrimaryName(assign_5.LHS.PrimaryType), arraySizeMap), foldAST(getContAssignments, empty(), new ASTNode(/* VerilogInput */ 21, [ast])))), list_11);
    const getArrayWordsTargeted = (assignmentSet) => fold_1((wordsSet, assignLHS) => {
        const matchValue = assignLHS.PrimaryType;
        let matchResult, id, id_2, indices;
        switch (matchValue.tag) {
            case 0: {
                matchResult = 0;
                id = matchValue.fields[0];
                break;
            }
            case 1: {
                matchResult = 1;
                break;
            }
            case 5: {
                matchResult = 2;
                id_2 = matchValue.fields[0];
                indices = matchValue.fields[1];
                break;
            }
            case 6: {
                matchResult = 2;
                id_2 = matchValue.fields[0];
                indices = matchValue.fields[1];
                break;
            }
            case 2: {
                matchResult = 3;
                break;
            }
            case 4: {
                matchResult = 4;
                break;
            }
            default: {
                matchResult = 0;
                id = matchValue.fields[0];
            }
        }
        switch (matchResult) {
            case 0: {
                const matchValue_1 = tryFind(id.Name, arraySizeMap);
                if (matchValue_1 == null) {
                    return wordsSet;
                }
                else {
                    matchValue_1[0];
                    return union(wordsSet, ofList(map_1((i) => (((id.Name + "[") + int32ToString(i)) + "]"), toList(rangeDouble(0, 1, item_4(0, matchValue_1[1]) - 1))), {
                        Compare: (x_6, y_6) => (comparePrimitives(x_6, y_6) | 0),
                    }));
                }
            }
            case 1:
                return add(((matchValue.fields[0].Name + "[") + int32ToString(matchValue.fields[1])) + "]", wordsSet);
            case 2: {
                const matchValue_2 = item_4(0, indices);
                if (matchValue_2.tag === 1) {
                    const matchValue_3 = tryFind(id_2.Name, arraySizeMap);
                    if (matchValue_3 == null) {
                        return wordsSet;
                    }
                    else {
                        matchValue_3[0];
                        return union(wordsSet, ofList(map_1((i_1) => (((id_2.Name + "[") + int32ToString(i_1)) + "]"), toList(rangeDouble(0, 1, item_4(0, matchValue_3[1]) - 1))), {
                            Compare: (x_7, y_7) => (comparePrimitives(x_7, y_7) | 0),
                        }));
                    }
                }
                else {
                    return add(((id_2.Name + "[") + int32ToString(matchValue_2.fields[0])) + "]", wordsSet);
                }
            }
            case 3:
                return wordsSet;
            default:
                return wordsSet;
        }
    }, empty_1({
        Compare: (x_8, y_8) => (comparePrimitives(x_8, y_8) | 0),
    }), assignmentSet);
    const arrayNames = ofList(toList(keys(arraySizeMap)), {
        Compare: (x_9, y_9) => (comparePrimitives(x_9, y_9) | 0),
    });
    const indexedAssignmentBits = indexed(filter((bits) => isEmpty_1(intersect(bits, arrayNames)), alwaysAssignmentBits));
    const indexedAssignmentArrayBits = indexed(alwaysAssignmentArrayBits);
    const duplicates = List_distinct(collect((tupledArg) => {
        const _arg = tupledArg[0];
        const _arg_1 = tupledArg[1];
        if (equals(_arg[0], _arg_1[0])) {
            return empty();
        }
        else {
            return toList_1(intersect(_arg[1], _arg_1[1]));
        }
    }, allPairs(indexedAssignmentBits, indexedAssignmentBits)), {
        Equals: (x_10, y_10) => (x_10 === y_10),
        GetHashCode: (x_10) => (stringHash(x_10) | 0),
    });
    const duplicateArrays = List_distinct(collect((tupledArg_1) => {
        const _arg_2 = tupledArg_1[0];
        const _arg_3 = tupledArg_1[1];
        if (equals(_arg_2[0], _arg_3[0])) {
            return empty();
        }
        else {
            return toList_1(intersect(getArrayWordsTargeted(_arg_2[1]), getArrayWordsTargeted(_arg_3[1])));
        }
    }, allPairs(indexedAssignmentArrayBits, indexedAssignmentArrayBits)), {
        Equals: (x_11, y_11) => (x_11 === y_11),
        GetHashCode: (x_11) => (stringHash(x_11) | 0),
    });
    return append(errorList, append(isEmpty(duplicates) ? empty() : createErrorMessage(linesLocations, ast.Module.EndLocation, "Some ports or variables are driven by multiple always blocks or continuous assignments.", [new ExtraErrorInfo((arg = convert(duplicates, ""), toText(printf("The following variables are driven by multiple always blocks or continuous assignments: %A.  Please make sure that every port is driven by at most one always block or continuous assignment."))(arg)), false, ReplaceType.NoReplace)], "endmodule"), isEmpty(duplicateArrays) ? empty() : createErrorMessage(linesLocations, ast.Module.EndLocation, "Some array words may be driven by multiple always blocks or continuous assignments.", [new ExtraErrorInfo((arg_1 = convert(duplicateArrays, ""), toText(printf("The following array words may be driven by multiple always blocks or continuous assignments: %A. Please make sure that every word is driven by at most one always block or continuous assignment."))(arg_1)), false, ReplaceType.NoReplace)], "endmodule")));
}

/**
 * Checks array assignments
 * - disallows multi-word assignment (unless assigning whole array)
 * - only 2d arrays allowed
 */
export function checkArrayStatements(ast, linesLocations, arraySizeMap, errorList) {
    return append(errorList, append(collect((decl) => collect((variable) => {
        if (containsKey(variable.Name, arraySizeMap)) {
            const patternInput = find(variable.Name, arraySizeMap);
            if (patternInput[1].length > 1) {
                return createErrorMessage(linesLocations, variable.Location, toText(printf("Array has more than 2 dimensions.")), [new ExtraErrorInfo(toText(printf("Only 2D arrays are supported. Please make sure that array %A has at most 2 dimensions."))(variable.Name), false, ReplaceType.NoReplace)], variable.Name);
            }
            else {
                return empty();
            }
        }
        else {
            return empty();
        }
    }, ofArray(decl.Variables)), foldAST(getDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))), collect((assign_1) => {
        const matchValue = assign_1.LHS.PrimaryType;
        switch (matchValue.tag) {
            case 2: {
                const id = matchValue.fields[0];
                const lhsName = id.Name;
                return createErrorMessage(linesLocations, id.Location, toText(printf("Multi-word assignment to array %A"))(lhsName), [new ExtraErrorInfo(toText(printf("Assignments cannot be made to multiple words in an array at once. Please either assign to one word of the array, or to the entire array.")), false, ReplaceType.NoReplace)], lhsName);
            }
            case 5: {
                const id_1 = matchValue.fields[0];
                const lhsName_1 = id_1.Name;
                if (matchValue.fields[1].length > 1) {
                    return createErrorMessage(linesLocations, id_1.Location, toText(printf("Array has more than 2 dimensions.")), [new ExtraErrorInfo(toText(printf("Only 2D arrays are supported. Please make sure that array %A has at most 2 dimensions."))(lhsName_1), false, ReplaceType.NoReplace)], lhsName_1);
                }
                else {
                    return empty();
                }
            }
            default:
                return empty();
        }
    }, filter((assign) => containsKey(getPrimaryName(assign.LHS.PrimaryType), arraySizeMap), foldAST(getAssignments$0027, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))))));
}

/**
 * Checks the case items of the case statements:
 * - Repeated cases
 * - Wrong width
 */
export function checkCasesStatements(ast, linesLocations, portSizeMap, wireSizeMap, arraySizeMap, paramMap, errorList) {
    const portSizeMap_1 = fold_2((acc, key, value) => add_1(key, value, acc), portSizeMap, fold((map, decl) => fold_3((map$0027, variable) => {
        if (decl.Range == null) {
            return add_1(variable.Name, 0, map$0027);
        }
        else {
            return add_1(variable.Name, (evalExprWithParams(value_3(decl.Range).Start, paramMap) - evalExprWithParams(value_3(decl.Range).End, paramMap)) + 1, map$0027);
        }
    }, map, decl.Variables), wireSizeMap, foldAST(getDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))));
    return append(errorList, collect((tupledArg) => {
        const caseStmt = tupledArg[0];
        const condWidth = getWidthOfExpr(caseStmt.Expression, portSizeMap_1, arraySizeMap, paramMap) | 0;
        if (condWidth === 0) {
            return empty();
        }
        else {
            const caseNumbers = collect_1((caseItem) => caseItem.Expressions, caseStmt.CaseItems);
            const repeatedErrors = fold_3((tupledArg_1, caseNumber) => {
                let arg;
                const casesCovered = tupledArg_1[0];
                let patternInput;
                if (caseNumber.tag === 0) {
                    const numBase = caseNumber.fields[1];
                    const baseText = (numBase.tag === 2) ? "\'h" : ((numBase.tag === 1) ? "\'d" : "\'b");
                    patternInput = [int32ToString(caseNumber.fields[0]), baseText, caseNumber.fields[2], caseNumber.fields[3]];
                }
                else {
                    patternInput = ["", "\'d", int32ToString(caseNumber.fields[0]), caseNumber.fields[1]];
                }
                const width = patternInput[0];
                const numBase_1 = patternInput[1];
                const num_1 = patternInput[2];
                const loc_2 = patternInput[3] | 0;
                const caseNumberDec = toDecimal(num_1, numBase_1, width);
                let repeatedError;
                if (containsKey(caseNumberDec, casesCovered)) {
                    const firstLine = getLineNumber(linesLocations, find(caseNumberDec, casesCovered)) | 0;
                    repeatedError = createErrorMessage(linesLocations, loc_2, "Duplicate case value", [new ExtraErrorInfo((arg = ((width + numBase_1) + num_1), toText(printf("The following case value is duplicated: %A, see line %A. Please make sure there are no repeated case values."))(arg)(firstLine)), false, ReplaceType.NoReplace)], (width + numBase_1) + num_1);
                }
                else {
                    repeatedError = empty();
                }
                const widthError = (parse(width, 511, false, 32) !== condWidth) ? createErrorMessage(linesLocations, loc_2, "Width of case value does not match \n the given case expression", [new ExtraErrorInfo(toText(printf("Width of case expression (%A bits wide) does not match width of this case item (%A bits wide)."))(condWidth)(width), false, ReplaceType.NoReplace), new ExtraErrorInfo((int32ToString(condWidth) + numBase_1) + num_1, true, new ReplaceType(/* Variable */ 2, [(width + numBase_1) + num_1]))], (width + numBase_1) + num_1) : empty();
                return [add_1(caseNumberDec, loc_2, casesCovered), append(tupledArg_1[1], append(repeatedError, widthError))];
            }, [empty_2({
                Compare: (x, y) => (compare_1(x, y) | 0),
            }), empty()], caseNumbers)[1];
            if (caseStmt.Default == null) {
                return repeatedErrors;
            }
            else {
                return repeatedErrors;
            }
        }
    }, foldAST(getCaseStatementsWithLoc, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))));
}

/**
 * Used for checking if a variable is assigned in every branch, see checkVariablesAlwaysAssigned
 */
export function allCasesCovered(caseStmt, portSizeMap, wireSizeMap, arraySizeMap, paramMap) {
    if (caseStmt.Default != null) {
        return true;
    }
    else {
        const condWidth = getWidthOfExpr(caseStmt.Expression, fold_2((acc, key, value) => add_1(key, value, acc), portSizeMap, wireSizeMap), arraySizeMap, paramMap) | 0;
        if (condWidth === 0) {
            return true;
        }
        else {
            const expNrOfCases = op_LeftShift(fromOne(), condWidth);
            const caseNumbers = collect_1((caseItem) => caseItem.Expressions, caseStmt.CaseItems);
            const caseNumsUnique = fold_3((casesCovered, caseNumber) => {
                let numBase;
                return add((caseNumber.tag === 0) ? ((numBase = caseNumber.fields[1], toDecimal(caseNumber.fields[2], (numBase.tag === 2) ? "\'h" : ((numBase.tag === 1) ? "\'d" : "\'b"), int32ToString(caseNumber.fields[0])))) : fromInt32(caseNumber.fields[0]), casesCovered);
            }, empty_1({
                Compare: (x, y) => (compare_1(x, y) | 0),
            }), caseNumbers);
            return count(difference(ofList(toList(rangeBigInt(fromZero(), 1n, op_Subtraction(expNrOfCases, fromOne()))), {
                Compare: (x_1, y_1) => (compare_1(x_1, y_1) | 0),
            }), caseNumsUnique)) === 0;
        }
    }
}

export function checkVariablesAlwaysAssigned(ast, linesLocations, portSizeMap, wireSizeMap, arraySizeMap, paramMap, errorList) {
    const wireSizeMap_1 = fold((map, decl) => fold_3((map$0027, variable) => {
        if (decl.Range == null) {
            return add_1(variable.Name, 1, map$0027);
        }
        else {
            return add_1(variable.Name, (evalExprWithParams(value_3(decl.Range).Start, paramMap) - evalExprWithParams(value_3(decl.Range).End, paramMap)) + 1, map$0027);
        }
    }, map, decl.Variables), wireSizeMap, foldAST(getDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [ast])));
    const portSizeMap_1 = fold_2((acc, key, value) => add_1(key, value, acc), portSizeMap, wireSizeMap_1);
    const getVariablesAlwaysAssigned = (node_1_mut) => {
        getVariablesAlwaysAssigned:
        while (true) {
            const node_1 = node_1_mut;
            switch (node_1.tag) {
                case 21: {
                    const itemsCompleteVariables = map_2((item) => getVariablesAlwaysAssigned(new ASTNode(/* Item */ 18, [item])), convertModule(node_1.fields[0].Module).ModuleItems.ItemList);
                    return fold_3(union, empty_1({
                        Compare: (x, y) => (comparePrimitives(x, y) | 0),
                    }), itemsCompleteVariables);
                }
                case 18: {
                    node_1_mut = getItem(node_1.fields[0]);
                    continue getVariablesAlwaysAssigned;
                }
                case 4: {
                    node_1_mut = (new ASTNode(/* Statement */ 5, [node_1.fields[0].Statement]));
                    continue getVariablesAlwaysAssigned;
                }
                case 5: {
                    const statement = node_1.fields[0];
                    switch (statement.tag) {
                        case 0:
                            return ofList(getLHSBitsAssignedCertainly(portSizeMap_1, paramMap, statement.fields[0]), {
                                Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
                            });
                        case 2: {
                            const completeVariables = map_2((s) => getVariablesAlwaysAssigned(new ASTNode(/* Statement */ 5, [s])), statement.fields[0]);
                            return fold_3(union, empty_1({
                                Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
                            }), completeVariables);
                        }
                        case 3: {
                            node_1_mut = (new ASTNode(/* Case */ 6, [statement.fields[0]]));
                            continue getVariablesAlwaysAssigned;
                        }
                        case 4: {
                            const elseStmt = statement.fields[1];
                            const ifVariables = getVariablesAlwaysAssigned(new ASTNode(/* Statement */ 5, [statement.fields[0].Statement]));
                            const elseVariables = (elseStmt == null) ? empty_1({
                                Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
                            }) : getVariablesAlwaysAssigned(new ASTNode(/* Statement */ 5, [elseStmt]));
                            if (elseStmt == null) {
                                return empty_1({
                                    Compare: (x_5, y_5) => (comparePrimitives(x_5, y_5) | 0),
                                });
                            }
                            else {
                                return intersect(ifVariables, elseVariables);
                            }
                        }
                        case 5: {
                            node_1_mut = (new ASTNode(/* Statement */ 5, [unrollForLoops(statement.fields[0])]));
                            continue getVariablesAlwaysAssigned;
                        }
                        default:
                            return ofList(getLHSBitsAssignedCertainly(portSizeMap_1, paramMap, statement.fields[0]), {
                                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                            });
                    }
                }
                case 6: {
                    const case$_1 = node_1.fields[0];
                    if (allCasesCovered(case$_1, portSizeMap_1, wireSizeMap_1, arraySizeMap, paramMap)) {
                        const complCaseVars = map_2((caseItem) => getVariablesAlwaysAssigned(new ASTNode(/* Statement */ 5, [caseItem.Statement])), case$_1.CaseItems);
                        const caseItemVars = fold_3(intersect, item_4(0, complCaseVars), complCaseVars);
                        const matchValue = case$_1.Default;
                        if (matchValue == null) {
                            return caseItemVars;
                        }
                        else {
                            return intersect(getVariablesAlwaysAssigned(new ASTNode(/* Statement */ 5, [matchValue])), caseItemVars);
                        }
                    }
                    else {
                        return empty_1({
                            Compare: (x_6, y_6) => (comparePrimitives(x_6, y_6) | 0),
                        });
                    }
                }
                default:
                    return empty_1({
                        Compare: (x_7, y_7) => (comparePrimitives(x_7, y_7) | 0),
                    });
            }
            break;
        }
    };
    return fold((errors, variables) => append(errors, createErrorMessage(linesLocations, variables[1], "Some ports or variables might not always be assigned to", [new ExtraErrorInfo(toText(printf("The following variables might be undefined as they are not assigned to in every branch of conditional statements or case statements in the always_comb block: ")) + convert(variables[0], ""), false, ReplaceType.NoReplace)], "always_comb")), errorList, filter((tupledArg_3) => !equals(tupledArg_3[0], empty()), map_1((tupledArg_1) => {
        const always_1 = tupledArg_1[0];
        const validAssignedBits = ofList(collect((assign) => {
            const lhs = getPrimaryName(assign.LHS.PrimaryType);
            const matchValue_1 = tryFind(lhs, portSizeMap_1);
            if (matchValue_1 == null) {
                return empty();
            }
            else {
                return map_1((bit) => (((lhs + "[") + int32ToString(bit)) + "]"), toList(rangeDouble(0, 1, matchValue_1 - 1)));
            }
        }, foldAST(getAssignments$0027, empty(), new ASTNode(/* AlwaysConstruct */ 4, [always_1]))), {
            Compare: (x_8, y_8) => (comparePrimitives(x_8, y_8) | 0),
        });
        const loopVars = ofList(map_1((tupledArg_2) => getPrimaryName(tupledArg_2[0].Initialisation.LHS.PrimaryType), foldAST(getForStatementsWithLoc, empty(), new ASTNode(/* AlwaysConstruct */ 4, [always_1]))), {
            Compare: (x_9, y_9) => (comparePrimitives(x_9, y_9) | 0),
        });
        return [toList_1(map_3((varBit_1) => item_4(0, varBit_1.split("[")), difference(filter_1((varBit) => !contains(item_4(0, varBit.split("[")), loopVars), intersect(validAssignedBits, ofList(collect((assignment) => getLHSBits$0027(portSizeMap_1, assignment), foldAST(getAssignments$0027, empty(), new ASTNode(/* AlwaysConstruct */ 4, [always_1]))), {
            Compare: (x_10, y_10) => (comparePrimitives(x_10, y_10) | 0),
        }))), getVariablesAlwaysAssigned(new ASTNode(/* AlwaysConstruct */ 4, [always_1]))), {
            Compare: (x_11, y_11) => (comparePrimitives(x_11, y_11) | 0),
        })), tupledArg_1[1]];
    }, filter((tupledArg) => equals(tupledArg[0].AlwaysType, AlwaysDU.AlwaysComb), foldAST(getAlwaysBlocksWithLocations, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))))));
}

/**
 * Check if expressions are correct
 * - Indexes within range
 * - Numbers are correctly formatted
 */
export function checkExpressions(ast, linesLocations, wireSizeMap, arraySizeMap, paramMap, errorList) {
    let linesLocations_1;
    const wireSizeMap_1 = fold((map, decl) => fold_3((map$0027, variable) => {
        if (decl.Range == null) {
            return add_1(variable.Name, 1, map$0027);
        }
        else {
            return add_1(variable.Name, (evalExprWithParams(value_3(decl.Range).Start, paramMap) - evalExprWithParams(value_3(decl.Range).End, paramMap)) + 1, map$0027);
        }
    }, map, decl.Variables), wireSizeMap, foldAST(getDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [ast])));
    const expressions_1 = foldAST(getAllExpressions$0027, empty(), new ASTNode(/* VerilogInput */ 21, [ast]));
    const caseItemNums = foldAST(getCaseItemNums, empty(), new ASTNode(/* VerilogInput */ 21, [ast]));
    return append(errorList, append(collect((expr) => checkExpr(linesLocations, wireSizeMap_1, arraySizeMap, paramMap, empty(), expr), expressions_1), collect((linesLocations_1 = linesLocations, (num) => {
        if (num.tag === 0) {
            const numBase = num.fields[1];
            const loc = num.fields[3] | 0;
            const bits = num.fields[0] | 0;
            if (bits === 0) {
                return createErrorMessage(linesLocations_1, loc, "Number can\'t be 0 bits wide", [new ExtraErrorInfo("Number can\'t be 0 bits wide", false, ReplaceType.NoReplace), new ExtraErrorInfo("The integer before \'h/\'b represents the width of the number\n e.g. 12\'hc7 -> 000011000111", false, ReplaceType.NoReplace)], "0\'b");
            }
            else {
                const matchValue = strToIntCheckWidth(bits, toString(toDecimal(num.fields[2], (numBase.tag === 2) ? "\'h" : ((numBase.tag === 1) ? "\'d" : "\'b"), "64")));
                return (matchValue.tag === 1) ? createErrorMessage(linesLocations_1, loc, toText(printf("Number can\'t fit in %A bits"))(bits), [new ExtraErrorInfo(toText(printf("Number can\'t fit in %A bits"))(bits), false, ReplaceType.NoReplace), new ExtraErrorInfo("The integer before \'h/\'b represents the width of the number\n e.g. 12\'hc7 -> 000011000111", false, ReplaceType.NoReplace)], "0\'b") : empty();
            }
        }
        else {
            return empty();
        }
    }), caseItemNums)));
}

/**
 * Checks that clk is an input port when there are always_ff blocks
 */
export function checkClk(ast, linesLocations, portMap, errorList) {
    const alwaysFFsWithLoc = filter((always) => equals(always.AlwaysType, AlwaysDU.AlwaysFF), foldAST(getAlwaysBlocks, empty(), new ASTNode(/* VerilogInput */ 21, [ast])));
    const matchValue = tryFind("clk", portMap);
    let matchResult;
    if (matchValue != null) {
        if (matchValue.tag === 1) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return fold((errors, always_1) => append(errors, createErrorMessage(linesLocations, always_1.ClkLoc, "Variable \'clk\' is not defined as an input port.", append_1([new ExtraErrorInfo(toText(printf("To use always_ff blocks, please make sure to include \'clk\' in the port list.")), false, ReplaceType.NoReplace)], (ast.Module.Type === "module_new") ? [] : [new ExtraErrorInfo("input bit clk;", true, ReplaceType.IODeclaration)]), "clk")), errorList, alwaysFFsWithLoc);
        default:
            return errorList;
    }
}

/**
 * Checks if:
 * - no output ports are called clk
 * - clk has width 1
 * - any of the expressions use clk
 */
export function checkClkNames(ast, linesLocations, portMap, portLocationMap, portSizeMap, errorList) {
    let matchValue, matchValue_1, location, matchValue_3, extraMessages_1, option_1, option_3, matchValue_4, matchValue_5, l_1, location_2;
    const declarations_1 = collect_1((decl) => decl.Variables, toArray(foldAST(getDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))));
    const contAssigns = map_2((assign) => assign.LHS.PrimaryType, toArray(foldAST(getContAssignments, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))));
    return append(errorList, append((matchValue = tryFind("clk", portMap), (matchValue_1 = tryFind("clk", portLocationMap), (matchValue != null) ? ((matchValue.tag === 1) ? ((matchValue_1 != null) ? ((location = (matchValue_1 | 0), createErrorMessage(linesLocations, location, "\'clk\' must be an input port", [new ExtraErrorInfo(toText(printf("\'clk\' represents the clock signal, which must be an input port")), false, ReplaceType.NoReplace)], "clk"))) : empty()) : empty()) : empty())), append((matchValue_3 = tryFind_1((y) => ("clk" === y), append_1(map_2((id) => id.Name, declarations_1), map_2(getPrimaryName, contAssigns))), (matchValue_3 == null) ? empty() : ((extraMessages_1 = [new ExtraErrorInfo(toText(printf("\'clk\' is reserved for the clock signal, please rename the variable")), false, ReplaceType.NoReplace)], createErrorMessage(linesLocations, defaultArg(orElse((option_1 = tryFind_1((id_1) => (id_1.Name === "clk"), declarations_1), (option_1 != null) ? option_1.Location : undefined), (option_3 = tryFind_1((p_1) => (getPrimaryName(p_1) === "clk"), contAssigns), (option_3 != null) ? getPrimaryLocation(option_3) : undefined)), ast.Module.EndLocation), "Variable cannot be called \'clk\'", extraMessages_1, "clk")))), append((matchValue_4 = tryFind("clk", portSizeMap), (matchValue_5 = tryFind("clk", portLocationMap), (matchValue_4 != null) ? ((matchValue_5 != null) ? ((matchValue_4 > 1) ? ((l_1 = (matchValue_4 | 0), (location_2 = (matchValue_5 | 0), createErrorMessage(linesLocations, location_2, "\'clk\' must have width 1", [new ExtraErrorInfo(toText(printf("\'clk\' represents the clock signal, which must have width 1, here it has width %A"))(l_1), false, ReplaceType.NoReplace)], "clk")))) : empty()) : empty()) : empty())), fold((errors, primary) => {
        const extraMessages_3 = [new ExtraErrorInfo(toText(printf("\'clk\' represents the clock signal, make sure to only use it as \'always_ff @(posedge clk)\'")), false, ReplaceType.NoReplace)];
        return append(errors, createErrorMessage(linesLocations, getPrimaryLocation(primary), "Illegal use of \'clk\'", extraMessages_3, getPrimaryName(primary)));
    }, empty(), filter((prim) => (getPrimaryName(prim) === "clk"), fold(primariesUsedInAssignment, empty(), foldAST(getAllExpressions$0027, empty(), new ASTNode(/* VerilogInput */ 21, [ast])))))))));
}

/**
 * Looks for cycles in the general dependency graph using depth first search
 */
export function findCycleDFS(graph) {
    const dfs = (node, visited, recStack, path) => {
        if (FSharpSet__Contains(recStack, node)) {
            return cons(node, path);
        }
        else if (FSharpSet__Contains(visited, node)) {
            return undefined;
        }
        else {
            const visited$0027 = FSharpSet__Add(visited, node);
            const recStack$0027 = FSharpSet__Add(recStack, node);
            return fold((acc, neighbor) => {
                const matchValue = dfs(neighbor, visited$0027, recStack$0027, cons(node, path));
                if (matchValue == null) {
                    return acc;
                }
                else {
                    return matchValue;
                }
            }, undefined, defaultArg(tryFind(node, graph), empty()));
        }
    };
    return tryPick((node_1) => dfs(node_1, empty_1({
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), empty_1({
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }), empty()), keys(graph));
}

function getDependencies(ast, variableSizeMap) {
    const getDependencyFold = (graph_mut, astNode_mut, cond_mut) => {
        getDependencyFold:
        while (true) {
            const graph = graph_mut, astNode = astNode_mut, cond = cond_mut;
            let matchValue_1;
            switch (astNode.tag) {
                case 21: {
                    graph_mut = graph;
                    astNode_mut = (new ASTNode(/* ModuleItems */ 19, [convertModule(astNode.fields[0].Module).ModuleItems]));
                    cond_mut = cond;
                    continue getDependencyFold;
                }
                case 19:
                    return fold_3((acc, item) => getDependencyFold(acc, new ASTNode(/* Item */ 18, [item]), cond), graph, astNode.fields[0].ItemList);
                case 18: {
                    graph_mut = graph;
                    astNode_mut = getItem(astNode.fields[0]);
                    cond_mut = cond;
                    continue getDependencyFold;
                }
                case 2: {
                    graph_mut = graph;
                    astNode_mut = (new ASTNode(/* Assignment */ 10, [astNode.fields[0].Assignment]));
                    cond_mut = cond;
                    continue getDependencyFold;
                }
                case 10: {
                    const assign = astNode.fields[0];
                    const lhsBits = getLHSBits$0027(variableSizeMap, assign);
                    let rhsBits;
                    const rhs = getRHSBits(variableSizeMap, assign.RHS);
                    const matchValue = assign.LHS.VariableBitSelect;
                    rhsBits = ((matchValue == null) ? rhs : union(rhs, getRHSBits(variableSizeMap, matchValue)));
                    return fold((graph$0027, lhs) => add_1(lhs, union(rhsBits, cond), graph$0027), graph, lhsBits);
                }
                case 4: {
                    const always = astNode.fields[0];
                    if (equals(always.AlwaysType, AlwaysDU.AlwaysComb)) {
                        graph_mut = graph;
                        astNode_mut = (new ASTNode(/* Statement */ 5, [always.Statement]));
                        cond_mut = cond;
                        continue getDependencyFold;
                    }
                    else {
                        return graph;
                    }
                }
                case 5: {
                    const statement = astNode.fields[0];
                    switch (statement.tag) {
                        case 0: {
                            graph_mut = graph;
                            astNode_mut = (new ASTNode(/* Assignment */ 10, [statement.fields[0]]));
                            cond_mut = cond;
                            continue getDependencyFold;
                        }
                        case 2:
                            return fold_3((acc_1, st) => getDependencyFold(acc_1, new ASTNode(/* Statement */ 5, [st]), cond), graph, statement.fields[0]);
                        case 3: {
                            graph_mut = graph;
                            astNode_mut = (new ASTNode(/* Case */ 6, [statement.fields[0]]));
                            cond_mut = cond;
                            continue getDependencyFold;
                        }
                        case 4: {
                            const elseStmt = statement.fields[1];
                            const g = getDependencyFold(graph, new ASTNode(/* IfStatement */ 8, [statement.fields[0]]), cond);
                            if (elseStmt == null) {
                                return g;
                            }
                            else {
                                graph_mut = g;
                                astNode_mut = (new ASTNode(/* Statement */ 5, [elseStmt]));
                                cond_mut = cond;
                                continue getDependencyFold;
                            }
                        }
                        case 5: {
                            graph_mut = graph;
                            astNode_mut = (new ASTNode(/* ForStatement */ 9, [statement.fields[0]]));
                            cond_mut = cond;
                            continue getDependencyFold;
                        }
                        default: {
                            graph_mut = graph;
                            astNode_mut = (new ASTNode(/* Assignment */ 10, [statement.fields[0]]));
                            cond_mut = cond;
                            continue getDependencyFold;
                        }
                    }
                }
                case 6: {
                    const case$_1 = astNode.fields[0];
                    const condDependencies = getRHSBits(variableSizeMap, case$_1.Expression);
                    const allDeps = append(ofArray(map_2((item_2) => getDependencyFold(graph, new ASTNode(/* CaseItem */ 7, [item_2]), union(condDependencies, cond)), case$_1.CaseItems)), singleton_1((matchValue_1 = case$_1.Default, (matchValue_1 != null) ? getDependencyFold(graph, new ASTNode(/* Statement */ 5, [matchValue_1]), union(cond, condDependencies)) : empty_2({
                        Compare: (x, y) => (comparePrimitives(x, y) | 0),
                    }))));
                    return fold((acc_2, branch) => fold_2((acc$0027, key, value_1) => {
                        const matchValue_2 = tryFind(key, acc$0027);
                        return (matchValue_2 == null) ? add_1(key, value_1, acc$0027) : add_1(key, union(matchValue_2, value_1), acc$0027);
                    }, acc_2, branch), empty_2({
                        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                    }), allDeps);
                }
                case 7: {
                    graph_mut = graph;
                    astNode_mut = (new ASTNode(/* Statement */ 5, [astNode.fields[0].Statement]));
                    cond_mut = cond;
                    continue getDependencyFold;
                }
                case 8: {
                    const ifstmt = astNode.fields[0];
                    graph_mut = graph;
                    astNode_mut = (new ASTNode(/* Statement */ 5, [ifstmt.Statement]));
                    cond_mut = union(cond, getRHSBits(variableSizeMap, ifstmt.Condition));
                    continue getDependencyFold;
                }
                case 9: {
                    graph_mut = graph;
                    astNode_mut = (new ASTNode(/* Statement */ 5, [astNode.fields[0].Statement]));
                    cond_mut = cond;
                    continue getDependencyFold;
                }
                default:
                    return graph;
            }
            break;
        }
    };
    return map_4((_arg, value_2) => toList_1(value_2), getDependencyFold(empty_2({
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    }), ast, empty_1({
        Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
    })));
}

/**
 * Check for dependency cycles in always_comb blocks and continuous assignments
 */
export function cycleCheck(ast, linesLocations, portSizeMap, wireSizeMap, errorList) {
    const cycle = findCycleDFS(getDependencies(new ASTNode(/* VerilogInput */ 21, [ast]), fold_2((acc, key, value) => add_1(key, value, acc), wireSizeMap, portSizeMap)));
    if (cycle != null) {
        const path = cycle;
        const extraMessages = [new ExtraErrorInfo(toText(printf("The following variables form a cycle: %A"))(path), false, ReplaceType.NoReplace)];
        return append(errorList, createErrorMessage(linesLocations, ast.Module.EndLocation, toText(printf("The following variables form a dependency cycle: %A"))(path), extraMessages, "endmodule"));
    }
    else {
        return errorList;
    }
}

/**
 * Look for unassigned variables (not outputs, just variables)
 */
export function checkVariablesUsed(ast, linesLocations, portSizeMap, wireSizeMap, paramMap, arraySizeMap, errorList) {
    let extraMessages_1;
    const wireAndPortSizeMap = fold_2((acc, key, value) => add_1(key, value, acc), wireSizeMap, portSizeMap);
    const moduleInstantiationPorts = ofList(collect((conn) => getPrimaryBits(wireAndPortSizeMap, conn.Primary), collect((modInst) => ofArray(modInst.Connections), foldAST(getModuleInstantiationStatements, empty(), new ASTNode(/* VerilogInput */ 21, [ast])))), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const assignmentsLHS = union(moduleInstantiationPorts, ofList(collect((assign) => getLHSBits$0027(wireAndPortSizeMap, assign), foldAST(getAssignments$0027, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }));
    const wordLabels = (name) => {
        const matchValue = tryFind(name, arraySizeMap);
        if (matchValue == null) {
            return undefined;
        }
        else {
            return map_1((w) => (((name + "[") + int32ToString(w)) + "]"), toList(rangeDouble(0, 1, item_4(0, matchValue[1]) - 1)));
        }
    };
    const varsNotAssigned = fold((errorBits, variable) => {
        if (contains(variable, assignmentsLHS)) {
            return errorBits;
        }
        else {
            return append(errorBits, singleton_1(variable));
        }
    }, empty(), collect((decl) => collect((var$) => {
        const matchValue_1 = wordLabels(var$.Name);
        if (matchValue_1 == null) {
            const matchValue_2 = decl.Range;
            if (matchValue_2 != null) {
                const range = matchValue_2;
                const bStart = evalExprWithParams(range.Start, paramMap) | 0;
                const bEnd = evalExprWithParams(range.End, paramMap) | 0;
                return toList(delay(() => map_5((bit) => (((var$.Name + "[") + int32ToString(bit)) + "]"), rangeDouble(bEnd, 1, bStart))));
            }
            else {
                return singleton_1(var$.Name + "[0]");
            }
        }
        else {
            return matchValue_1;
        }
    }, ofArray(decl.Variables)), foldAST(getDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))));
    let varsNotAssignedErrs;
    if (isEmpty(varsNotAssigned)) {
        varsNotAssignedErrs = empty();
    }
    else {
        const extraMessages = [new ExtraErrorInfo(toText(printf("The following variables have not been assigned %A"))(varsNotAssigned), false, ReplaceType.NoReplace)];
        varsNotAssignedErrs = createErrorMessage(linesLocations, ast.Module.EndLocation, toText(printf("The following variables have not been assigned %A"))(varsNotAssigned), extraMessages, "endmodule");
    }
    const assignmentsRHS = union(moduleInstantiationPorts, ofList(collect((assign_1) => toList_1(getRHSBits(wireAndPortSizeMap, assign_1.RHS)), foldAST(getAssignments$0027, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    }));
    const arraysNotAssigned = fold((errorBits_1, variable_1) => {
        if (contains(variable_1, assignmentsRHS)) {
            return errorBits_1;
        }
        else {
            return append(errorBits_1, singleton_1(variable_1));
        }
    }, empty(), collect((decl_1) => collect((var$_1) => defaultArg(wordLabels(var$_1.Name), empty()), ofArray(decl_1.Variables)), foldAST(getDeclarations, empty(), new ASTNode(/* VerilogInput */ 21, [ast]))));
    return append(errorList, append(varsNotAssignedErrs, isEmpty(arraysNotAssigned) ? empty() : ((extraMessages_1 = [new ExtraErrorInfo(toText(printf("Arrays cannot be outputs, and so should be read from. \n The following arrays have not been read from %A"))(arraysNotAssigned), false, ReplaceType.NoReplace)], createErrorMessage(linesLocations, ast.Module.EndLocation, toText(printf("The following arrays have not been read from %A"))(arraysNotAssigned), extraMessages_1, "endmodule")))));
}

/**
 * Helper function for checking if any variable or port being written to after it is read in always_comb blocks.
 */
export function getVariablesWrittenAfterRead(wireAndPortSizeMap_mut, linesLocations_mut, rhsVars_mut, errors_mut, node_mut) {
    getVariablesWrittenAfterRead:
    while (true) {
        const wireAndPortSizeMap = wireAndPortSizeMap_mut, linesLocations = linesLocations_mut, rhsVars = rhsVars_mut, errors = errors_mut, node = node_mut;
        let arg;
        switch (node.tag) {
            case 10: {
                const assign = node.fields[0];
                const lhsBits = ofList(getLHSBits$0027(wireAndPortSizeMap, assign), {
                    Compare: (x, y) => (comparePrimitives(x, y) | 0),
                });
                const rhsBits = getRHSBits(wireAndPortSizeMap, assign.RHS);
                const assignedAfterRHS = intersect(lhsBits, rhsVars);
                const rhsVars$0027 = union(rhsVars, rhsBits);
                if (count(assignedAfterRHS) === 0) {
                    return [rhsVars$0027, errors];
                }
                else {
                    const location = getPrimaryLocation(assign.LHS.PrimaryType) | 0;
                    const extraMessages = [new ExtraErrorInfo((arg = convert(toList_1(map_3((var$) => item_4(0, var$.split("[")), assignedAfterRHS, {
                        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                    })), ""), toText(printf("The following variables are read and then updated: %A This creates undefined behaviour in an always_comb block, please make sure to not update a variable after it is read."))(arg)), false, ReplaceType.NoReplace)];
                    return [rhsVars$0027, append(errors, createErrorMessage(linesLocations, location, toText(printf("Variable written to after it is read")), extraMessages, getPrimaryName(assign.LHS.PrimaryType)))];
                }
            }
            case 8: {
                const ifstmt = node.fields[0];
                wireAndPortSizeMap_mut = wireAndPortSizeMap;
                linesLocations_mut = linesLocations;
                rhsVars_mut = union(rhsVars, getRHSBits(wireAndPortSizeMap, ifstmt.Condition));
                errors_mut = errors;
                node_mut = (new ASTNode(/* Statement */ 5, [ifstmt.Statement]));
                continue getVariablesWrittenAfterRead;
            }
            case 6: {
                const case$ = node.fields[0];
                const patternInput = unzip(ofArray(map_2((item) => getVariablesWrittenAfterRead(wireAndPortSizeMap, linesLocations, rhsVars, empty(), new ASTNode(/* Statement */ 5, [item.Statement])), case$.CaseItems)));
                let patternInput_1;
                const matchValue = case$.Default;
                patternInput_1 = ((matchValue != null) ? getVariablesWrittenAfterRead(wireAndPortSizeMap, linesLocations, rhsVars, empty(), new ASTNode(/* Statement */ 5, [matchValue])) : [empty_1({
                    Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
                }), empty()]);
                return [fold(union, empty_1({
                    Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
                }), append(patternInput[0], singleton_1(patternInput_1[0]))), append(fold(append, empty(), patternInput[1]), patternInput_1[1])];
            }
            case 5: {
                const stmt_1 = node.fields[0];
                switch (stmt_1.tag) {
                    case 0: {
                        wireAndPortSizeMap_mut = wireAndPortSizeMap;
                        linesLocations_mut = linesLocations;
                        rhsVars_mut = rhsVars;
                        errors_mut = errors;
                        node_mut = (new ASTNode(/* Assignment */ 10, [stmt_1.fields[0]]));
                        continue getVariablesWrittenAfterRead;
                    }
                    case 2:
                        return fold_3((tupledArg, node_3) => getVariablesWrittenAfterRead(wireAndPortSizeMap, linesLocations, tupledArg[0], tupledArg[1], node_3), [rhsVars, errors], map_2((s) => (new ASTNode(/* Statement */ 5, [s])), stmt_1.fields[0]));
                    case 3: {
                        wireAndPortSizeMap_mut = wireAndPortSizeMap;
                        linesLocations_mut = linesLocations;
                        rhsVars_mut = rhsVars;
                        errors_mut = errors;
                        node_mut = (new ASTNode(/* Case */ 6, [stmt_1.fields[0]]));
                        continue getVariablesWrittenAfterRead;
                    }
                    case 4: {
                        const elseStmt = stmt_1.fields[1];
                        const patternInput_2 = getVariablesWrittenAfterRead(wireAndPortSizeMap, linesLocations, rhsVars, empty(), new ASTNode(/* IfStatement */ 8, [stmt_1.fields[0]]));
                        const patternInput_3 = (elseStmt == null) ? [empty_1({
                            Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
                        }), empty()] : getVariablesWrittenAfterRead(wireAndPortSizeMap, linesLocations, rhsVars, empty(), new ASTNode(/* Statement */ 5, [elseStmt]));
                        return [union(patternInput_2[0], patternInput_3[0]), append(errors, append(patternInput_2[1], patternInput_3[1]))];
                    }
                    case 5: {
                        wireAndPortSizeMap_mut = wireAndPortSizeMap;
                        linesLocations_mut = linesLocations;
                        rhsVars_mut = rhsVars;
                        errors_mut = errors;
                        node_mut = (new ASTNode(/* ForStatement */ 9, [stmt_1.fields[0]]));
                        continue getVariablesWrittenAfterRead;
                    }
                    default: {
                        wireAndPortSizeMap_mut = wireAndPortSizeMap;
                        linesLocations_mut = linesLocations;
                        rhsVars_mut = rhsVars;
                        errors_mut = errors;
                        node_mut = (new ASTNode(/* Assignment */ 10, [stmt_1.fields[0]]));
                        continue getVariablesWrittenAfterRead;
                    }
                }
            }
            case 4: {
                wireAndPortSizeMap_mut = wireAndPortSizeMap;
                linesLocations_mut = linesLocations;
                rhsVars_mut = rhsVars;
                errors_mut = errors;
                node_mut = (new ASTNode(/* Statement */ 5, [node.fields[0].Statement]));
                continue getVariablesWrittenAfterRead;
            }
            default:
                return [rhsVars, errors];
        }
        break;
    }
}

/**
 * check that if an always block writes to and reads from the same variable, variable is assigned first and written later
 * a=1; b=a; a=0; -> this shouldn't be allowed
 */
export function checkAlwaysCombRHS(ast, linesLocations, portSizeMap, wireSizeMap, errorList) {
    const wireAndPortSizeMap = fold_2((acc, key, value) => add_1(key, value, acc), wireSizeMap, portSizeMap);
    return append(errorList, collect((always_1) => getVariablesWrittenAfterRead(wireAndPortSizeMap, linesLocations, empty_1({
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), empty(), new ASTNode(/* AlwaysConstruct */ 4, [always_1]))[1], filter((always) => equals(always.AlwaysType, AlwaysDU.AlwaysComb), foldAST(getAlwaysBlocks, empty(), new ASTNode(/* VerilogInput */ 21, [ast])))));
}

/**
 * Checks if module instantiation statements are correct:
 * - Does a loaded component exist with the given name?
 * - Are the inputs and outputs the correct width?
 * - Are the portIds correct?
 * - Are all the ports connected?
 * - Are there any duplicate ports?
 * - Make sure inputs are inputs (they have been assigned something), outputs are not driven by anything
 * - Are parameters correct?
 */
export function checkModuleInstantiations(ast, linesLocations, portSizeMap, paramMap, items, project, portMap, errorList) {
    const moduleInstantiations_1 = foldAST(getModuleInstantiationStatements, empty(), new ASTNode(/* VerilogInput */ 21, [ast]));
    const loadedComponentNames = map_1((comp) => comp.Name, project.LoadedComponents);
    const loadedComponentNamesSet = ofList(loadedComponentNames, {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const lhsVariables = ofList(append(MapModule_KeysL(filter_2((k, v) => equals(v, DeclarationDU.InputDecl), portMap)), map_1((assign) => getPrimaryName(assign.LHS.PrimaryType), foldAST(getAssignments$0027, empty(), new ASTNode(/* VerilogInput */ 21, [ast])))), {
        Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
    });
    return append(errorList, append(collect((modInst_2) => {
        let matchValue_4, p, matchValue_6, arg_8, modInst_1, comp_2, inputPorts_1, outputPorts;
        fold_2((acc_1, key, value) => add_1(key, value, acc_1), getWireSizeMap(items, (matchValue_4 = modInst_2.Parameters, (matchValue_4 == null) ? paramMap : ((p = matchValue_4, fold_3((acc, overridenParam) => add_1(overridenParam.Identifier.Name, evalExpr(overridenParam.Value), acc), empty_2({
            Compare: (x_6, y_6) => (comparePrimitives(x_6, y_6) | 0),
        }), p))))), portSizeMap);
        let moduleTypeErrors;
        if (contains(modInst_2.Module.Name, loadedComponentNamesSet)) {
            moduleTypeErrors = empty();
        }
        else {
            const message_3 = toText(printf("Component %s does not exist"))(modInst_2.Module.Name);
            const closeVariables = findCloseVariable(modInst_2.Module.Name.split(""), loadedComponentNames);
            moduleTypeErrors = createErrorMessage(linesLocations, modInst_2.Module.Location, message_3, append_1([new ExtraErrorInfo(toText(printf("Component \'%s\' does not exist - there is no custom component or Verilog component with this name"))(modInst_2.Module.Name), false, ReplaceType.NoReplace)], (matchValue_6 = isEmpty(closeVariables), matchValue_6 ? [] : [new ExtraErrorInfo((arg_8 = item_5(0, closeVariables), toText(printf("%s"))(arg_8)), true, new ReplaceType(/* Variable */ 2, [modInst_2.Module.Name]))])), modInst_2.Module.Name);
        }
        const matchValue_7 = filter((comp_3) => (comp_3.Name === modInst_2.Module.Name), project.LoadedComponents);
        if (!isEmpty(matchValue_7)) {
            if (isEmpty(tail(matchValue_7))) {
                let list_10;
                const modInst = modInst_2;
                const comp_1 = head(matchValue_7);
                const givenPortNames = ofArray_1(map_2((conn) => conn.PortId.Name.toLocaleUpperCase(), modInst.Connections), {
                    Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                });
                const expectedPortNames = ofList(map_1((tuple) => tuple[0], append(comp_1.InputLabels, comp_1.OutputLabels)), {
                    Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
                });
                const extraPortNames = difference(givenPortNames, expectedPortNames);
                const missingPortNames = difference(expectedPortNames, givenPortNames);
                list_10 = append(collect((conn_1) => {
                    if (contains(conn_1.PortId.Name.toLocaleUpperCase(), extraPortNames)) {
                        const extraMessages = [new ExtraErrorInfo(toText(printf("The port %A does not exist for component %A"))(conn_1.PortId.Name)(modInst.Module.Name), false, ReplaceType.NoReplace)];
                        return createErrorMessage(linesLocations, conn_1.PortId.Location, toText(printf("No such port for the given component")), extraMessages, conn_1.PortId.Name);
                    }
                    else {
                        return empty();
                    }
                }, ofArray(modInst.Connections)), collect((portName) => {
                    if (contains(portName, missingPortNames)) {
                        const extraMessages_1 = [new ExtraErrorInfo(toText(printf("The port %A missing for component %A"))(portName)(modInst.Module.Name), false, ReplaceType.NoReplace)];
                        return createErrorMessage(linesLocations, modInst.Module.Location, toText(printf("Missing port(s) for component")), extraMessages_1, modInst.Module.Name);
                    }
                    else {
                        return empty();
                    }
                }, toList_1(expectedPortNames)));
                append((modInst_1 = modInst_2, (comp_2 = head(matchValue_7), (inputPorts_1 = ofList(map_1((tuple_1) => tuple_1[0], comp_2.InputLabels), {
                    Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
                }), (outputPorts = ofList(map_1((tuple_2) => tuple_2[0], comp_2.OutputLabels), {
                    Compare: (x_5, y_5) => (comparePrimitives(x_5, y_5) | 0),
                }), collect((conn_2) => {
                    let arg_4;
                    const matchValue = contains(conn_2.PortId.Name.toLocaleUpperCase(), inputPorts_1);
                    const matchValue_1 = contains(conn_2.PortId.Name.toLocaleUpperCase(), outputPorts);
                    const matchValue_2 = contains(getPrimaryName(conn_2.Primary), lhsVariables);
                    let matchResult;
                    if (matchValue) {
                        if (matchValue_2) {
                            if (matchValue_1) {
                                matchResult = 1;
                            }
                            else {
                                matchResult = 2;
                            }
                        }
                        else {
                            matchResult = 0;
                        }
                    }
                    else if (matchValue_1) {
                        if (matchValue_2) {
                            matchResult = 1;
                        }
                        else {
                            matchResult = 2;
                        }
                    }
                    else {
                        matchResult = 2;
                    }
                    switch (matchResult) {
                        case 0:
                            return empty();
                        case 1: {
                            const extraMessages_2 = [new ExtraErrorInfo((arg_4 = getPrimaryName(conn_2.Primary), toText(printf("Output port %A in module %A is already driven by continuous or procedural assignments"))(arg_4)(modInst_1.Module.Name)), false, ReplaceType.NoReplace)];
                            const message_2 = toText(printf("Output port already driven"));
                            return createErrorMessage(linesLocations, getPrimaryLocation(conn_2.Primary), message_2, extraMessages_2, getPrimaryName(conn_2.Primary));
                        }
                        default:
                            return empty();
                    }
                }, ofArray(modInst_1.Connections)))))), list_10);
            }
            else {
                toFail(printf("There are multiple custom components with this name!"));
            }
        }
        else {
            empty();
        }
        return moduleTypeErrors;
    }, moduleInstantiations_1), collect((modInst_3) => fold_3((tupledArg, conn_3) => {
        let extraMessages_4;
        const ports = tupledArg[1];
        return [append(tupledArg[0], contains(conn_3.PortId.Name, ports) ? ((extraMessages_4 = [new ExtraErrorInfo(toText(printf("Duplicate port name \'%s\' for module %s"))(conn_3.PortId.Name)(modInst_3.Module.Name), false, ReplaceType.NoReplace)], createErrorMessage(linesLocations, conn_3.PortId.Location, toText(printf("Duplicate port")), extraMessages_4, conn_3.PortId.Name))) : empty()), add(conn_3.PortId.Name, ports)];
    }, [empty(), empty_1({
        Compare: (x_7, y_7) => (comparePrimitives(x_7, y_7) | 0),
    })], modInst_3.Connections)[0], moduleInstantiations_1)));
}

